import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {trans} from '../../helpers/HelperGlobal';
import {Button, Checkbox, Form, Input} from 'antd';
import MaskedInput from 'antd-mask-input';
import HelperGeneral from '../../helpers/HelperGeneral';
import {Col, Row} from 'react-bootstrap';
import {setGlobalSpinner} from '../../services/redux/actions/GeneralAction';
import UserInfo from '../auth/UserInfo';
import KvkkModal from '../partials/KvkkModal';
import Countdown, {zeroPad} from 'react-countdown';
import Api from '../../services/Api';
import moment from "moment";
import LogoScroller from "../partials/LogoScroller";

class Register extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            info: {},
            userRegisterData: {},
            kvkkType: null,
            kvkk_1: false,
            kvkk_2: false,
            kvkk_3: false,
            width: window.innerWidth,
            date: null
        };
    }

    componentDidMount() {
        if (UserInfo.isLogin()) {
            HelperGeneral.pageChange(this, '/home');
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (UserInfo.isLogin()) {
            HelperGeneral.pageChange(this, '/home');
        }
    }

    resize = () => this.setState({width: window.innerWidth});

    loginSubmit = (e) => {
        const {step, kvkk_1, kvkk_2, kvkk_3, userRegisterData, info} = this.state;

        if (step === 1) {
            setGlobalSpinner(true);
            try {
                let data = {
                    telephone: e?.mobilePhone,
                    type: 'register',
                    sendType: 'sms',
                }

                Api.createContactOtp(data).then(r => {
                    userRegisterData.telephone = e?.mobilePhone;
                    this.setState({
                        step: 2,
                        info: r?.data,
                        userRegisterData: userRegisterData,
                        date: Date.now() + ((r.data?.expired) * 1000)
                    }, () => {
                        setGlobalSpinner(false);
                    })
                }).catch((e) => {
                    setGlobalSpinner(false);
                    HelperGeneral.alert(e);
                })
            } catch (e) {
                setGlobalSpinner(false);
                HelperGeneral.alert(e);
            }
        } else if (step === 2) {
            setGlobalSpinner(true);
            userRegisterData.type = info?.sendType;
            userRegisterData.code = e?.code;

            let data = {
                operation_type: info?.type,
                telephone: userRegisterData?.telephone,
                code: userRegisterData?.code,
                send_type: userRegisterData?.type,
            };

            Api.verifyOtp(data).then(r => {
                this.setState({
                    step: 3,
                    date: null,
                    userRegisterData: userRegisterData
                }, () => {
                    setGlobalSpinner(false);
                })
            }).catch((e) => {
                setGlobalSpinner(false);
                HelperGeneral.alert(e);
            })
        } else if (step === 3) {
            setGlobalSpinner(true);
            try {
                if (!kvkk_1) {
                    setGlobalSpinner(false);
                    throw new Error('Kullanıcı Sözleşmesini kabul etmelisiniz.');
                }

                if(kvkk_2) {
                    userRegisterData.kvkk = 1;
                }

                if(kvkk_3) {
                    userRegisterData.permission_email = 1;
                    userRegisterData.permission_sms = 1;
                } else {
                    userRegisterData.permission_email = 0;
                    userRegisterData.permission_sms = 0;
                }

                userRegisterData.first_name = e.firstName;
                userRegisterData.last_name = e.lastName;
                userRegisterData.user_name = e.firstName + ' ' + e.lastName;
                userRegisterData.email = e.email;
                userRegisterData.new_password = e.password;
                userRegisterData.birthday = moment("2025-06-30T12:46:53.116Z").format('YYYY/MM/DD');
                userRegisterData.gender = 0;
                userRegisterData.permission_newsletter = 0;
                userRegisterData.permission_call = 0;
                userRegisterData.permission_mobile_push = 0;
                userRegisterData.token = true;
                userRegisterData.invitation_code = '';
                userRegisterData.after_login = true;
                userRegisterData.sms = info;

                Api.customerCreate(userRegisterData).then(r => {
                    this.setState(
                        {
                            info: {},
                            userRegisterData: {},
                        }, () => {
                            setGlobalSpinner(false);
                            HelperGeneral.pageChange(this, '/login');
                            return HelperGeneral.alert('Üye kaydınız başarıyla tamalanmıştır. Giriş yapabilirsiniz.', 'success')
                        }
                    )
                }).catch((e) => {
                    setGlobalSpinner(false);
                    HelperGeneral.alert(e);
                })
            } catch (e) {
                HelperGeneral.alert(e, 'error');
                setGlobalSpinner(false);
            }
        }
    }

    render() {
        const {step, kvkkType, kvkk_1, kvkk_2, kvkk_3, width, date, info} = this.state;

        let buttonTitle = 'Kod Gönder';
        let help = (
            <>
                Lütfen sisteme kaydetmek istediğiniz telefon numaranızı bu alana giriniz.
                Tüketici hesabınızı oluşturabilmek için SMS kodunu doğrulamanız istenecektir.
                Kod Gönder butonuna basarak <b
                    className="checkbox-text"
                    onClick={() => this.setState({ kvkkType: "kvkk_2" })}
                    style={{ cursor: "pointer" }}
                >
                    Aydınlatma Metni
                </b>
                ’ni okuduğunuzu ve <b
                    className="checkbox-text"
                    onClick={() => this.setState({ kvkkType: "kvkk_1" })}
                    style={{ cursor: "pointer" }}
                >
                Kullanıcı Sözleşmesi
                </b>
                ’ni onayladığınızı kabul edersiniz.
            </>
        );
        if (step === 2) {
            buttonTitle = 'Kodu Doğrula';
        } else if (step === 3) {
            buttonTitle = 'Tüketici Kaydını Tamamla';
        }

        return (
            <>
                <div className={'login-area'} style={width <= 991 ? {backgroundColor: '#FDE5D9'} : {}}>
                    <Row className={'w-100 h-100'}>
                        <Col className={'p-0 d-none d-lg-block logo-col'} lg={3} xxl={4}>
                            <LogoScroller className={'logo-div left-side'}/>
                        </Col>
                        <Col className={'p-0 my-auto'} xs={12} lg={6} xxl={4}>
                            <div className={'right'}>
                                <div className={'login'}>
                                    <div className="logo">
                                        <img src={require('../../assets/images/png/theme/SHINIQ_Logo.png')} alt={trans('title')}/>
                                    </div>
                                    <div className={'form-area'}>
                                        <Form
                                            name={'login'}
                                            initialValues={{
                                                mobilePhone: step === 3 ? info?.telephone : undefined
                                            }}
                                            onFinish={(e) => this.loginSubmit(e)}
                                            layout={'vertical'}
                                        >
                                            {
                                                [1, 3].includes(step) && (
                                                    <Form.Item
                                                        name={'mobilePhone'}
                                                        label={"Telefon Numarası"}
                                                        rules={[
                                                            {
                                                                validator: (_, value) => {
                                                                    const digits = String(value || "").replace(/\D/g, "");

                                                                    if (digits.length === 0) {
                                                                        return Promise.reject(
                                                                            new Error("Telefon numarası zorunludur")
                                                                        );
                                                                    }

                                                                    if (digits.length !== 12) {
                                                                        return Promise.reject(
                                                                            new Error("Telefon numarasını eksiksiz giriniz")
                                                                        );
                                                                    }

                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                        extra={step === 1 ? <div className={'mt-2 mb-2'}>{help}</div> : null}
                                                    >
                                                        <MaskedInput
                                                            mask={'(\\+90)111-111-11-11'}
                                                            autoComplete={'new-password'}
                                                            disabled={step === 3}
                                                            type={'tel'}
                                                        />
                                                    </Form.Item>
                                                )
                                            }
                                            {
                                                step === 2 && (
                                                    <>
                                                        <div className={'password-reset'}>
                                                            {trans('t3')}
                                                            <span className={'time'}>
                                                                <Countdown
                                                                    precision={0}
                                                                    renderer={({minutes, seconds}) => (
                                                                        <span>
                                                                            {
                                                                                trans('t2',
                                                                                    {
                                                                                        minutes: zeroPad(minutes),
                                                                                        seconds: zeroPad(seconds),
                                                                                    }
                                                                                )
                                                                            }
                                                                        </span>
                                                                    )}
                                                                    onComplete={() => this.setState({step: (step - 1)},
                                                                        () => {
                                                                            this.setState({date: null})
                                                                            if (step === 2) {
                                                                                HelperGeneral.alert('Doğrulama süresi sona erdi.');
                                                                            }
                                                                        })
                                                                    }
                                                                    date={date}
                                                                />
                                                            </span>
                                                        </div>
                                                        <Form.Item
                                                            name={'code'}
                                                            rules={[
                                                                () => ({
                                                                    validator(_, value) {
                                                                        const v = HelperGeneral.telephoneClear(value);
                                                                        if (v.length === 5) {
                                                                            return Promise.resolve()
                                                                        }
                                                                        return Promise.reject(new Error(trans('login.t22')))
                                                                    },
                                                                })]}
                                                            help={'Telefonunuza gönderilen 5 haneli onay kodunu giriniz.'}
                                                        >
                                                            <MaskedInput
                                                                mask={'11111'}
                                                                autoComplete={'new-password'}
                                                                size={5}
                                                            />
                                                        </Form.Item>
                                                    </>
                                                )
                                            }
                                            {
                                                step === 3 && (
                                                    <>
                                                        <Form.Item
                                                            label={"İsminiz"}
                                                            name={"firstName"}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                },
                                                            ]}
                                                        >
                                                            <Input/>
                                                        </Form.Item>

                                                        <Form.Item
                                                            label={"Soyisminiz"}
                                                            name={"lastName"}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                },
                                                            ]}
                                                        >
                                                            <Input/>
                                                        </Form.Item>
                                                        <Form.Item
                                                            label={"Email"}
                                                            name={"email"}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                },
                                                            ]}
                                                        >
                                                            <Input placeholder="example@mail.com"/>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name={"password"}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: trans('t14'),
                                                                    min: 8,
                                                                },
                                                            ]}
                                                            label={trans('t11')}
                                                        >
                                                            <Input.Password autoComplete={'new-password'}/>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name={"new_password_confirm"}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: trans('t15'),
                                                                    min: 8,
                                                                },
                                                                ({getFieldValue}) => ({
                                                                    validator(_, value) {
                                                                        if (!value || getFieldValue('password') === value) {
                                                                            return Promise.resolve()
                                                                        }
                                                                        return Promise.reject(new Error(trans('Şifreler uyuşmamaktadır')))
                                                                    },
                                                                }),
                                                            ]}
                                                            label={trans('t12')}
                                                        >
                                                            <Input.Password
                                                                autoComplete={'new-password'}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            name={"kvkk_1"}
                                                            valuePropName={"checked"}
                                                            className={'checkbox'}
                                                        >
                                                            <Checkbox
                                                                value={'kvkk_1'}
                                                                onChange={(value) => this.setState({kvkk_1: value.target.checked})}
                                                                checked={kvkk_1}
                                                            />
                                                            <a
                                                                onClick={() => this.setState({kvkkType: 'kvkk_1'})}
                                                                className={'checkbox-text'}
                                                            >
                                                                <a style={{color: '#ff4d4f'}}>*</a>Kullanıcı Sözleşmesini okudum, kabul ediyorum.
                                                            </a>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name={"kvkk_2"}
                                                            className={'checkbox'}
                                                            valuePropName={"checked"}
                                                        >
                                                            <Checkbox
                                                                value={'kvkk_2'}
                                                                onChange={(value) => this.setState({kvkk_2: value.target.checked})}
                                                                checked={kvkk_2}
                                                            />
                                                            <a style={{cursor: 'default'}}>
                                                                <b className={'checkbox-text'} onClick={() => this.setState({kvkkType: 'kvkk_2'})}>Aydınlatma Metni</b>nde belirtilen şekilde kişisel verilerimin işlenmesine <b className={'checkbox-text'} onClick={() => this.setState({kvkkType: 'kvkk_3'})}>Açık Rıza</b> gösteriyorum.
                                                            </a>
                                                        </Form.Item>
                                                        <Form.Item
                                                            name={"kvkk_3"}
                                                            valuePropName={"checked"}
                                                            className={'checkbox'}>
                                                            <Checkbox
                                                                value={'kvkk_3'}
                                                                onChange={(value) => this.setState({kvkk_3: value.target.checked})}
                                                                checked={kvkk_3}
                                                            />
                                                            <a
                                                                onClick={() => this.setState({kvkkType: 'kvkk_4'})}
                                                                className={'checkbox-text'}
                                                            >
                                                                E-posta ve SMS Ticari Elektronik İleti metnini okudum,onaylıyorum. Tarafınızdan gönderilecek bilgilendirmeleri almak istiyorum.
                                                            </a>
                                                        </Form.Item>
                                                    </>
                                                )
                                            }
                                            <Form.Item className={'m-0'}>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    className="login-form-button"
                                                >
                                                    {buttonTitle}
                                                </Button>
                                            </Form.Item>
                                            {
                                                step === 1 && (
                                                    <Form.Item className={'m-0'}>
                                                        <div className={'back-button mt-3'}>
                                                            <div>veya</div>
                                                            <div>
                                                                <Link to={'/giris-yap'}>
                                                                    Giriş sayfasına dönmek için tıklayın
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </Form.Item>
                                                )
                                            }
                                        </Form>
                                        <KvkkModal
                                            kvkkType={kvkkType}
                                            selectedKvkk={(kvkk) => {
                                                this.setState({
                                                    [kvkk]: true,
                                                    kvkkType: null,
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col className={'p-0 d-none d-lg-block logo-col'} lg={3} xxl={4}>
                            <LogoScroller className={'logo-div left-side'}/>
                        </Col>
                    </Row>
                </div>
            </>
        )
    }
}

export default withRouter(Register);
